<project-navigation
  [headerTitle]="data.fromDashBoard ? 'projectNavigation.my_projects' : 'projectNavigation.title_load_configuration'"
  [headerText]="data.fromDashBoard ? '' : 'projectNavigation.text_load_configuration'"
  [model]="model"
  [submitEnabled]="submitEnabled"
  [actionButtonLabel]="'global.label.load'"
  [visibleFeatures]="{
    compositeCheckBox: visibleCompositeCheckBox,
    pinnedProjects: true,
    recentlyUsedProjects: true,
    history: true,
    projectActionsMenu: true,
    projectGroupContextMenu: true,
    newConfigurationGroupBtn: true,
    newFolderBtn: true,
    dialogSearch: true,
    tabs: true,
    breadcrumbs: true,
  }"

  [compositeCheckBoxLabel]="'load.label.load_composite'"
  [isNewProjectCreation]="data.newProjectCreation"
  (submitEnabledChanged)="updateSubmitEnabled()"
  (actionBtnClick)="loadSelectedProject()"
  (submitSelectedConfiguration)="loadSelectedProject()"
  (cancel)="cancel()"
  (componentInitialized)="onInitializeSubComponent()"
></project-navigation>
